import React, {useState, useEffect} from "react";
import axios from "axios";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";

const Calendar = () => {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);

    useEffect (() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API}/booking-event`);
                const processedData = response.data.data.map((event) => {
                    const endDate = new Date(event.end);
                    endDate.setDate(endDate.getDate() + 1);

                    return {
                        ...event,
                        title: event.room_number
                            ? `${event.title} - ${event.room_number}`
                            : event.title,
                        end: endDate.toISOString().split("T")[0],
                        extendedProps: {
                            duration: event.duration,
                            description: event.description || "No description",
                            room_number: event.room_number,
                            floor: event.floor,
                            breakfast: event.breakfast,
                            originalTitle: event.title,
                            categoryId: event.categoryId,
                        },
                    };
                });

                setEvents(processedData);
            } catch (error) {
                console.error("Error fecthing events", error);
            }
        };

        fetchEvents();
    }, []);

    const handleEventClick = (clickInfo) => {
        const startDate = new Date(clickInfo.event.start);
        const endDate = new Date(clickInfo.event.end);
        endDate.setDate(endDate.getDate() - 1);

        setSelectedEvent({
            categoryId: clickInfo.event.extendedProps.categoryId,
            title: clickInfo.event.extendedProps.originalTitle,
            duration: clickInfo.event.extendedProps.duration,
            description: clickInfo.event.extendedProps.description,
            room_number: clickInfo.event.extendedProps.room_number,
            floor: clickInfo.event.extendedProps.floor,
            breakfast: clickInfo.event.extendedProps.breakfast,
            startDate: formatDateInIndonesian(startDate),
            endDate: formatDateInIndonesian(endDate),
        });
        
        const modal = new window.bootstrap.Modal(document.getElementById("eventModal"));
        modal.show();
    }

    return (
    <div class="row">
        <div class="col-lg-12 mb-4">
            <div class="card p-3 fullcalendar">
                <FullCalendar
                    plugins={[dayGridPlugin, listPlugin, bootstrap5Plugin]}
                    themeSystem="bootstrap5"
                    initialView="dayGridMonth"
                    views={{
                        listMonth: {
                            type: "list",
                            duration: { months: 12 } // ⬅️ ambil 12 bulan ke depan
                        }
                    }}
                    headerToolbar={{
                        left: "prev,next today",
                        center: "title",
                        right: "dayGridMonth,listMonth"
                    }}
                    buttonText={{
                        dayGridMonth: "month",
                        listMonth: "list"
                    }}
                    buttonIcons={{
                        prev: "chevron-left",
                        next: "chevron-right"
                    }}
                    displayEventTime={false} // ⬅️ hilangkan "all-day"
                    eventContent={(arg) => {
                        const isList = arg.view.type.includes("list");

                        if (isList) {
                            const date = new Date(arg.event.start);
                            const day = date.getDate();
                            const month = date.toLocaleString("id-ID", { month: "long" });
                            const year = date.getFullYear();

                            const title = arg.event.title;
                            const name = arg.event.extendedProps.description;

                            return (
                                <div style={{ fontSize: "14px" }}>
                                    <b>{day} {month} {year}</b> - {title} - {name}
                                </div>
                            );
                        }

                        return true;
                    }}
                    events={(info, successCallback) => {
                        const today = new Date();
                        const todayStr = today.toISOString().split("T")[0];

                        if (info.view?.type === "listMonth") {
                            const filtered = events.filter(event => {
                                // ambil hanya tanggal (YYYY-MM-DD)
                                const eventDateStr = event.start.split(" ")[0];

                                return eventDateStr >= todayStr;
                            });

                            successCallback(filtered);
                        } else {
                            successCallback(events);
                        }
                    }}
                    // events={events}
                    eventClick={handleEventClick}
                />
                {/* <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    events={events}
                    eventClick={handleEventClick}
                /> */}

                <div className="modal fade" id="eventModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title">{selectedEvent?.title}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                        <p><strong>Durasi:</strong> {selectedEvent?.duration} Night</p>
                        <p><strong>Check-in:</strong> {selectedEvent?.startDate}</p>
                        <p><strong>Check-out:</strong> {selectedEvent?.endDate}</p>
                        {selectedEvent?.room_number && (
                            <p><strong>Nomor Kamar:</strong> {selectedEvent.room_number}</p>
                        )}
                        {selectedEvent?.floor !== undefined && (
                            <p><strong>Lantai:</strong> {selectedEvent.floor}</p>
                        )}
                        {selectedEvent?.breakfast !== undefined && (
                            selectedEvent?.categoryId?.trim() === "CAT-HOTEL" ? (
                                <p><strong>Breakfast:</strong> {selectedEvent.breakfast === 'Y' ? 'Ya' : 'Tidak'}</p>
                            ) : (
                                <p><strong>Catering:</strong> {selectedEvent.breakfast === 'Y' ? 'Ya' : 'Tidak'}</p>
                            )
                        )}
                        <p><strong>Deskripsi:</strong> {selectedEvent?.description}</p>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

const formatDateInIndonesian = (date) => {
    const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    const months = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];
  
    return `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

export default Calendar;
